import { render, staticRenderFns } from "./OurAdv.vue?vue&type=template&id=127e23da&scoped=true&lang=html&"
import script from "./OurAdv.vue?vue&type=script&lang=js&"
export * from "./OurAdv.vue?vue&type=script&lang=js&"
import style0 from "./OurAdv.vue?vue&type=style&index=0&id=127e23da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e23da",
  null
  
)

export default component.exports